import Constants from '../../constants';

const { PublicFiles } = Constants;

const getFiles = (getType) => ({
  type: PublicFiles.GET_FILES,
  getType,
});

const getFilesError = (error) => ({
  type: PublicFiles.GET_FILES_ERROR,
  error,
});

const getFilesSuccess = (publicFilesUrls) => ({
  type: PublicFiles.GET_FILES_SUCCESS,
  publicFilesUrls,
});

const uploadFile = (file) => ({
  type: PublicFiles.UPLOAD_FILE,
  file,
});

const uploadFileError = (error) => ({
  type: PublicFiles.UPLOAD_FILE_ERROR,
  error,
});

const uploadFileSuccess = (publicFilesUrls) => ({
  type: PublicFiles.UPLOAD_FILE_SUCCESS,
  publicFilesUrls,
});

const uploadFileProgress = (progressEvent, file) => ({
  type: PublicFiles.UPLOAD_FILE_PROGRESS,
  progressEvent,
  file,
});

export default {
  getFiles,
  getFilesError,
  getFilesSuccess,
  uploadFile,
  uploadFileError,
  uploadFileProgress,
  uploadFileSuccess,
};
